RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsInsightsConsumptionView = widgets.PostDetailsColumnView.extend({
        className: 'facebook-insights-post-details facebook-insights-post-details-consumptions',
        columnWidth: 12
    });


    const FbPostDetailsInsightsConsumptionWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_insights_consumptions_title,
        description: RivalIQ.strings.facebook_insights_post_detail_insights_consumptions_description,
        view: FbPostDetailsInsightsConsumptionView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_CONSUMPTIONS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_insights_consumptions_metric_name
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_LINK_CLICKS',
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_PHOTO_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_VIDEO_PLAYS',
                            'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_OTHER_CLICKS'
                        ],
                        dimensions: ['className']
                    })
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_INSIGHTS_CONSUMPTION, FbPostDetailsInsightsConsumptionWidget);

});
